import * as ActionTypes from './action-types';

function loadingAction(isLoading) {
  return {
    type: ActionTypes.IS_LOADING,
    isLoading
  };
}

export function startLoading() {
  return loadingAction(true);
}

export function stopLoading() {
  return loadingAction(false);
}

export function openValidationRenewal(renewal) {
  return {
    type: ActionTypes.OPEN_VALIDATION_RENEWAL,
    renewal
  };
}

export function closeValidationRenewal() {
  return {
    type: ActionTypes.CLOSE_VALIDATION_RENEWAL
  };
}

export function updateSpecificRenewal(updatedRenewal) {
  return {
    type: ActionTypes.UPDATE_RENEWAL,
    updatedRenewal
  };
}
